module.exports = __webpack_public_path__ + "img/white-check.261e9a06.svg";